/**
 * Focus inside a shadow root is reported by that root, not by the document:
 * `document.activeElement` returns the shadow *host*. Anything that needs to
 * know what is focused — roving focus in a menu, a dialog's focus trap — has
 * to ask the containing root directly.
 */
export function activeElementWithin(node: Node | null): Element | null {
  const root = node?.getRootNode()
  if (root instanceof ShadowRoot || root instanceof Document) return root.activeElement
  return null
}

const FOCUSABLE =
  'a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex]:not([tabindex="-1"])'

/** Everything inside `root` that a Tab press could land on, in document order. */
export function focusableWithin(root: ParentNode): HTMLElement[] {
  return [...root.querySelectorAll<HTMLElement>(FOCUSABLE)]
}
